import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { projectFiles } from '@/mocks/evidence';

export default function ProjectFiles() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="项目文件"
            title="核心项目与规划文件"
            subtitle="九畴云市的项目文件、首发方案、复制路线与合规文件，构成项目可信的证据链。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {projectFiles.map((f, i) => (
            <Reveal key={f.title} delay={i * 80}>
              <div className="flex items-start gap-5 p-6 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors">
                <div className="w-14 h-14 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                  <i className={`${f.icon} text-accent-600 text-2xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg text-foreground-950">{f.title}</h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}